function createOverlay(image, zoomRatio) {
  const overlay = document.createElement('div');
  overlay.classList.add('image-magnify-full-size');
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.opacity = '50%'; // Устанавливаем начальную прозрачность

  const overlayImage = new Image();
  overlayImage.src = image.src;
  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    overlay.style.backgroundImage = `url('${overlayImage.src}')`;
    overlay.style.opacity = '100%'; // Убираем прозрачность после загрузки изображения
    image.style.opacity = '100%'; // Убираем прозрачность у изображения
  };
  overlayImage.onerror = () => {
    toggleLoadingSpinner(image);
    overlay.remove();
  };

  toggleLoadingSpinner(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();

  image.parentElement.insertBefore(overlay, image);

  return overlay;
}

// Функция подготовки оверлея
function prepareOverlay(container, image) {
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

// Функция переключения отображения индикатора загрузки
function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector('.loading__spinner');
  loadingSpinner.classList.toggle('hidden');
}

// Функция перемещения при наведении мыши
function moveWithHover(image, event, zoomRatio) {
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${(xPosition / image.clientWidth) * 100}%`;
  const yPercent = `${(yPosition / (image.clientWidth * ratio)) * 100}%`;

  const overlay = image.parentElement.querySelector('.image-magnify-full-size');
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

// Функция увеличения изображения при наведении
function magnify(image, zoomRatio) {
  createOverlay(image, zoomRatio);
}

// Функция активации зума при наведении мыши
function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onmousemove = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

// Активация зума при наведении на изображения с классом "image-magnify-hover" с коэффициентом увеличения 2
enableZoomOnHover(2);